
// tg stickers (animationData)


import useSourceStore from '../../Store/SourceStore';

export const onboardingConfig = {
    pages: [
        {
            slides: [
                {
                    media: {
                        type: 'animation',
                        get src() {
                            return useSourceStore.getState().onboardingImages.hello;
                        },
                        size: 200,
                    },
                    shape: 'square',
                    pagination: 'count',
                    title: '<b>Добро пожаловать <br/> в Dreamcoin!</br>',
                    description: "Это игра, в которой ты сможешь зарабатывать USDT.",
                    button: 'Круто, давай начнем! 🚀',
                },
                {
                    media: {
                        type: 'animation',
                        get src() {
                            return useSourceStore.getState().onboardingImages.dc;
                        },
                        size: 200,
                    },
                    shape: 'square',
                    pagination: 'count',
                    title: '<b>У нас есть своя важная валюта, называется DC.</b>',
                    description: "Она зарабатывается повсюду и за неё покупаются <b>персонажи</b>.",
                    button: 'Интересно! Дальше 👉',
                },
                {
                    media: {
                        type: 'animation',
                        get src() {
                            return useSourceStore.getState().onboardingImages.characters;
                        },
                        size: 250,
                    },
                    shape: 'square',
                    pagination: 'count',
                    title: '<b>Персонажи бывают разной редкости и цены.</b>',
                    description: "Они приносят USDT вместе с каждым сбором майнинга. Чем выше редкость персонажа, тем больше он приносит прибыли.",
                    button: 'Хочу персонажа! ⭐',
                },
                {
                    media: {
                        type: 'animation',
                        get src() {
                            return useSourceStore.getState().onboardingImages.mining;
                        },
                        size: 250,
                    },
                    shape: 'square',
                    pagination: 'count',
                    title: '<b>Майнинг дает тебе DC и USDT каждые 4 часа</b>',
                    description: "но ты можете ускорять его, просматривая рекламу.",
                    button: 'А как майнить? 💎',
                },
                {
                    media: {
                        type: 'animation',
                        get src() {
                            return useSourceStore.getState().onboardingImages.fortune;
                        },
                        size: 250,
                    },
                    shape: 'square',
                    pagination: 'count',
                    title: '<b>Колесо Фортуны позволит заработать намного больше.</b>',
                    description: "Для вращения колеса активируй ваучеры и выполняй ежедневный квест.",
                    button: 'Погнали играть! 🎮',
                },
            ],
        },
    ],
};